export enum PerformanceDataViewType {
    MARKET = 1,
    SITE,
    PEER_GROUP,
    SITE_PEER_GROUP,
    SUPER_GROUP,
    SITE_SUPER_GROUP,
    USER_SUPER_GROUP,
    AREA_PEER_GROUP,
    REGION_PEER_GROUP,
    AREA_SUPER_GROUP,
    REGION_SUPER_GROUP,
    AREA_LOB,
    REGION_LOB,
    TEAM_SUPER_GROUP,
    AREA,
    REGION,
    USER, // userId/managerId
    SITE_LOB,
    LOB = 20,
    USER_QUEUE,
    SUPER_GROUP_QUEUE,
    SITE_SUPER_GROUP_QUEUE,
}
